import DatePicker from 'components/calendar/date';
import React from 'react';
import { Checkbox } from 'components/ui/checkbox';
import { formatDate, toIsoStringWithTz } from 'utils/date-format';
import { IFilterConfig, IFilterConfigDate } from './types';

interface IProps {
  item: IFilterConfig;
  setSelected: (arg1: string, arg2: boolean) => void;
  setValue: (arg1: string, arg2: number, arg3: string) => void;
}

const DateFilter = ({ item, setSelected, setValue }: IProps): JSX.Element => {
  const { selected, key, label, data } = item;
  const { values } = data as IFilterConfigDate;
  const dateFrom =
    values[0] ||
    toIsoStringWithTz(new Date(new Date().setDate(new Date().getDate() - 30)));
  const dateTo =
    values[1] ||
    toIsoStringWithTz(new Date(new Date().setDate(new Date().getDate())));
  const applyDateFilter = (checked: boolean) => {
    setSelected(key, checked);
    setValue(key, 0, dateFrom);
    setValue(key, 1, dateTo);
  };
  return (
    <>
      <div className="flex items-center gap-2 px-2 py-1">
        <Checkbox
          id={label}
          data-testid="date-checkbox"
          data-cy="dateFilters"
          checked={selected}
          onCheckedChange={(checked) => applyDateFilter(checked === true)}
        />
        <label htmlFor={label} className="body-subtext-regular">
          {label}
        </label>
      </div>
      {selected && (
        <div className="flex items-center px-2 pb-2">
          <DatePicker
            initialValue={dateFrom ? formatDate(dateFrom, 'MM-dd-yyyy') : ''}
            setDate={(val: string) => setValue(key, 0, val)}
            beforeDate={formatDate(dateTo || '', 'MMM dd yyyy')}
            format="MM-DD-YYYY"
          />
          <small className="px-2 text-gray-blue-50">-</small>
          <DatePicker
            initialValue={dateTo ? formatDate(dateTo, 'MM-dd-yyyy') : ''}
            setDate={(val: string) => setValue(key, 1, val)}
            isEndDate
            afterDate={formatDate(dateFrom || '', 'MMM dd yyyy')}
            format="MM-DD-YYYY"
          />
        </div>
      )}
    </>
  );
};
export default DateFilter;
